import type { RouteRecordRaw } from 'vue-router';

/** Public Kosovo salary calculators (NB24 net→gross, BN24 gross→net) per Law
 *  Nr. 08/L-142. `skipTenantGuard` + `requiresAuth:false` make them reachable
 *  from any host with no login — open for all, tenants included. */
export const calculatorsRoutes: RouteRecordRaw[] = [
  {
    path: '/calculators',
    name: 'calculators',
    component: () => import('./pages/CalculatorsPage.vue'),
    meta: {
      title: 'Kalkulatorët e pagës',
      requiresAuth: false,
      skipTenantGuard: true,
    },
  },
];
